import React from 'react';
import { graphql } from 'react-apollo';
import MUIDataTable from "mui-datatables";
import { Grid } from '@material-ui/core';
// components
import { GET_REPORT_BY_PUBLISHER } from "../../../../queries/payments";
import PageError from '../../../../components/PageError';
import PageLoading from '../../../../components/PageLoading';
import PageTitle from "../../../../components/PageTitle/PageTitle";

const receivedPayments = ({ data: { paymentReceiptById, loading, error }}) => {

  const options = {
    selectableRows: 'none',
    responsive: "scrollMaxHeight"    
  };


  return (
    <>
    <Grid container spacing={0}>
        <Grid item xs={10}>
            <PageTitle title="Received Payments"/>
        </Grid>
    </Grid>
      {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={paymentReceiptById}
                columns={[
                  {
                    name    : 'id',
                    options : {
                      display : false
                    }
                  },
                  {
                    label   : 'Reference Date',
                    name    : 'referenceDate'                 
                  },
                  {
                    label   : 'Payment Date',
                    name    : 'paymentDate'                 
                  },
                  {
                    label   : 'Payment Value',
                    name    : 'paymentValue'                 
                  },
                  {
                    label   : 'Receipt',
                    name    : 'receiptLocation',
                    options: {
                      customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                          <a href={value} target="_blank" rel="noopener noreferrer">View Receipt</a>
                        );
                      }
                    }
                 
                  },
                  
                ]}
                options={options}
              />
            </Grid>
          </Grid>
        )
      }
  </>);
}

export const ReceivedPayments = graphql(GET_REPORT_BY_PUBLISHER, {options: (props) =>({ variables: { publisherId: localStorage.getItem('publisher-active') }})})(receivedPayments);